<template lang="pug">
  include ./../../../../../../../mixins
  div
    +b.form-base.cabinet-settings-form
      +b.form-top-info
        +b.form-title-wrapper
          +b.P.h1_title--cabinet {{ _("Мій профайл") }}
        +b.A.cabinet-action-link--red(
          v-if="formData.url"
          :href="formData.url"
        ) {{ _("Дивитися публічний профіль") }}
      +b.form-spliter-wrapper
        +b.form-spliter
      settings-main-info(
        ref="main"
        :form-data="formData"
        :initial-data="initialData"
        @updated="setData"
      )
    +b.ds-panel.--space_xl
      +e.element.--offset_top
        +b.form-base.cabinet-settings-form
          settings-attributes(
            :form-data="formData"
            :attributes="attributes"
            :initial-data="initialData"
            @updated="setData"
          )
</template>

<script>
import {
  userDetailInfoWithCityResource,
  userAttributesResource,
} from '@services/users.service'

export default {
  components: {
    'settings-main-info': () => import('../components/MainInfo'),
    'settings-attributes': () => import('../components/Attributes'),
  },

  data() {
    return {
      formData: {
        email: '',
        firstName: '',
        lastName: '',
        dateOfBirth: null,
        showMeInMeeting: false,
        country: {},
        region: {},
        city: {},
        attributes: {},
      },
      initialData: {},
      attributes: [],
    }
  },

  async mounted() {
    await this.getUserInfo()
    await this.getUserAttributes()
  },

  methods: {
    async getUserInfo() {
      await userDetailInfoWithCityResource.execute().then(res => {
        const { data: { item } } = res

        this.setData(item)
        this.getLocation()
      })
    },

    async getUserAttributes() {
      await userAttributesResource.execute().then(res => {
        const { data: { dynamicAttributes } } = res

        this.attributes = dynamicAttributes.map(el => el.props)

        this.setAttributes()
      })
    },

    getLocation() {
      this.$refs.main.getLocation()
    },

    setData(item) {
      const location = ['country', 'region', 'city']

      location.forEach(k => {
        if (!item[k]) {
          item[k] = {}
        }
      })

      this.formData = item
      this.initialData = JSON.parse(JSON.stringify(item))

      this.setAttributes()
    },

    setAttributes() {
      this.formData.attributes = {}

      this.attributes.forEach(item => {
        this.$set(this.formData.attributes, item.attribute.props.label, null)
      })

      this.initialData.attributes.forEach(item => {
        const attr = this.attributes.find(el => el.attribute.props.label === item.label)

        if (!attr) return

        if ('checkbox' === attr.createWidgetType) {
          const values = item.values.map(val => val.props.id)

          this.formData.attributes[item.label] = values
        } else if ('select' === attr.createWidgetType) {
          const [val] = item.values

          if (!val) return

          this.formData.attributes[item.label] = val.props.id
        } else {
          const [val] = item.values

          if (!val) return

          this.formData.attributes[item.label] = val.props.value
        }
      })
    },
  },
}

</script>
